import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useIntegrationTriggerReducer = () => useSelector((state: ApplicationState) => state.integrationTrigger);
